

export function html(html) {
    const template = document.createElement('template')
    if ('content' in template) {
        template.innerHTML = html
        return document.importNode(template.content, true)
    }
    const frag = document.createDocumentFragment()
    const div = document.createElement('div')
    div.innerHTML = html
    while (div.firstChild) {
        frag.appendChild(div.firstChild)
    }
    return frag
}


export function empty(node) {
	while (node.hasChildNodes()) node.removeChild(node.lastChild)
}